import styled, { css } from 'styled-components';

import { maxWidth } from '@utils/helpers';

import {
    CONTAINER_PADDING,
    CONTAINER_SIDE_PADDINGS,
    CONTAINER_WIDTH,
} from '@shared/constants';

export const LayoutWrapper = styled.div`
    height: 100%;
    width: 100%;
`;

export const LayoutInner = styled.div<{ hideFooter?: boolean }>(
    ({ hideFooter }) => css`
        display: grid;
        grid-template-columns: auto;
        grid-template-rows: ${hideFooter ? 'auto 1fr' : 'auto 1fr auto'};
        min-height: 100vh;
        position: relative;
        width: 100%;
    `,
);

const containerStyles = css`
    margin: 0 auto;
    max-width: calc(${CONTAINER_WIDTH}px + ${CONTAINER_PADDING('default')}px);
    padding: 0 ${CONTAINER_SIDE_PADDINGS.default}px;
    position: relative;
    width: 100%;

    ${maxWidth('md')} {
        max-width: calc(${CONTAINER_WIDTH}px + ${CONTAINER_PADDING('md')}px);
        padding: 0 ${CONTAINER_SIDE_PADDINGS.md}px;
    }

    ${maxWidth('sm')} {
        max-width: calc(${CONTAINER_WIDTH}px + ${CONTAINER_PADDING('xs')}px);
        padding: 0 ${CONTAINER_SIDE_PADDINGS.xs}px;
    }
`;

export const Container = styled.div`
    ${containerStyles}
`;

export const removeContainerPadding = (
    breakpoint: keyof typeof CONTAINER_SIDE_PADDINGS,
) => css`
    margin-left: -${CONTAINER_SIDE_PADDINGS[breakpoint]}px;
    width: calc(100% + ${CONTAINER_SIDE_PADDINGS[breakpoint] * 2}px);
`;
